<template>
  <div>
    <v-list v-if="lyrics != null">
      <v-btn flat icon color="green" @click="openDialog">
        <v-icon>library_books</v-icon>
      </v-btn>
      <v-layout row justify-center>
        <v-dialog v-model="lyricsDialog" width="600px">
          <v-card class="lyricsCard">
            <v-card-title>
              <span class="headline">{{ title }}<br>
              <span class="body-1">アーティスト&nbsp;&nbsp;/&nbsp;&nbsp;{{ artist }}</span></span>
            </v-card-title>
            <v-card-text>
              <div v-html="lyrics" style="white-space: pre-line;"></div>
            </v-card-text>
            <v-card-text v-if="introduction !== null">
              <h3 class="introductionTitle">紹介文</h3>
              <div v-html="introduction" style="white-space: pre-line;" class="introductionArea"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" @click="closeDialog">閉じる</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-list>
    <v-list v-else>
      <v-btn flat icon disabled>
        <v-icon>library_books</v-icon>
      </v-btn>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'Lyrics',
  data () {
    return {
      lyricsDialog: false
    }
  },
  props: ['lyrics', 'title', 'artist', 'introduction'],
  methods: {
    openDialog: function () {
      this.lyricsDialog = true
    },
    closeDialog: function () {
      this.lyricsDialog = false
    }
  }
}
</script>

<style scoped>
.introductionTitle {
  color: #15c06a;
  margin-bottom: 1rem;
}
.introductionArea {
  padding: 15px;
  border: #15c06a 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/Lyrics.vue